import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AndroidShare = ({
  height = 9,
  width = 11,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 11 9" {...props}>
    <path
      d="M10.9824 9C10.9247 8.92444 10.8673 8.84856 10.8089 8.77332C10.3442 8.17194 9.78467 7.64794 9.15163 7.22126C8.49602 6.78165 7.78003 6.47745 7.01725 6.27269C6.53343 6.14079 6.0383 6.0532 5.53816 6.01101C5.14466 5.98026 4.74983 5.96653 4.35534 5.94559C4.32814 5.94559 4.3006 5.94559 4.26443 5.94559V8.38768L0 4.18681L4.25813 0V2.37634C4.47678 2.4169 4.68945 2.4519 4.89881 2.4954C5.97445 2.71815 6.97312 3.12113 7.8633 3.76126C8.62127 4.30909 9.26299 4.99807 9.75216 5.78924C10.2409 6.56969 10.5869 7.40836 10.8271 8.29119C10.8898 8.52212 10.9426 8.75566 11 8.9879L10.9824 9Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
